import { Color, Emotion, Message } from "../Message";
import { Robot } from "../Robot";
import { hexToRgb, color_mapping } from "@/helpers/color_mappers";
import { generateId } from "@/helpers/utils";
import { getFetchOptions } from "@/helpers/network_helpers";

export class Furhat implements Robot {
  kind = "Furhat";
  errors: { time: Date; message: string; details: string }[] = [];
  id: string;
  isOn: boolean;
  ip: string;
  useFurhatTTS: boolean;

  constructor(ip: string, useFurhatTTS: boolean = true) {
    this.id = "Furhat" + generateId();
    this.ip = ip;
    this.isOn = true;
    this.useFurhatTTS = useFurhatTTS;
  }

  toggleTTS(): void {
    this.useFurhatTTS = !this.useFurhatTTS;
  }

  sendMessage(message: Message): void {
    this.sendEmotion(message.emotion);
    this.sendColor(message.color);
    this.sendSpeech(message.speech);
  }

  sendSpeech(speech: string): void {
    if (this.useFurhatTTS) {
      fetch(
        `http://${this.ip}:54321/furhat/say?` +
          new URLSearchParams({
            text: speech,
          }),
        getFetchOptions(
          {
            method: "POST",
            mode: "no-cors",
          },
          this.ip,
        ),
      ).catch((e: Error) => {
        this.errors = [
          ...this.errors,
          {
            time: new Date(Date.now()),
            message: `Could not send speech - ${e.message} - ${e.cause}`,
            details: `${e.stack}`,
          },
        ];
      });
    } else {
      // const utterance = new SpeechSynthesisUtterance(speech);
      // utterance.voice = this.selectedVoice;
      // TODO: Figure out how to extract the utterance rather than speak it
      // this.synth.speak(utterance);
      // fetch(`http://${this.ip}:54321/api/audio/play`, {
      //   method: "POST",
      //   mode:"no-cors",
      //   body: JSON.stringify({
      //     FileName: speech,
      //   }),
      // });
    }
  }

  sendEmotion(emotion: Emotion): void {
    fetch(
      `http://${this.ip}:54321/furhat/gesture?` +
        new URLSearchParams({
          name: {
            Neutral: "Smile",
            Surprised: "Surprise",
            Happy: "BigSmile",
            Sad: "ExpressSad",
            Concerned: "Oh",
            Sleepy: "CloseEyes",
          }[emotion],
        }),
      getFetchOptions(
        {
          method: "POST",
          mode: "no-cors",
        },
        this.ip,
      ),
    ).catch((e: Error) => {
      this.errors = [
        ...this.errors,
        {
          time: new Date(Date.now()),
          message: `Could not send emotion - ${e.message} - ${e.cause}`,
          details: `${e.stack}`,
        },
      ];
    });
  }

  sendColor(color: Color): void {
    const rgb = hexToRgb(color_mapping[color]) || { r: 0, g: 0, b: 0 };
    fetch(
      `http://${this.ip}:54321/furhat/led?` +
        new URLSearchParams({
          red: rgb.r.toString(),
          green: rgb.g.toString(),
          blue: rgb.b.toString(),
        }),
      getFetchOptions(
        {
          method: "POST",
          mode: "no-cors",
        },
        this.ip,
      ),
    ).catch((e: Error) => {
      this.errors = [
        ...this.errors,
        {
          time: new Date(Date.now()),
          message: `Could not send color - ${e.message} - ${e.cause}`,
          details: `${e.stack}`,
        },
      ];
    });
  }

  toString(): string {
    return JSON.stringify({
      kind: this.kind,
      ip: this.ip,
      useFurhatTTS: this.useFurhatTTS,
    });
  }

  toPrettyString(): string {
    return `Furhat at ${this.ip}`;
  }
}
